// src/timeControls.js
// Live timed mode constants — must stay in sync with phutball-workers/src/types.ts.

export const TIME_CONTROLS = ['blitz_5', 'rapid_10', 'classical_30', 'live', 'correspondence'];

// Per-move limits in milliseconds. null = no clock.
export const TIME_CONTROL_LIMITS_MS = {
  blitz_5: 5000,
  rapid_10: 10000,
  classical_30: 30000,
  live: null,
  correspondence: null,
};

// Live (real-time matchmaking) queues. Correspondence uses a separate
// challenge flow, not the live lobby pool.
export const LIVE_TIME_CONTROLS = ['blitz_5', 'rapid_10', 'classical_30', 'live'];

// User-facing labels.
export const TIME_CONTROL_LABELS = {
  blitz_5: 'Blitz (5s)',
  rapid_10: 'Rapid (10s)',
  classical_30: 'Classical (30s)',
  live: 'Live',
  correspondence: 'Correspondence',
};

// Compact labels for narrow UI elements.
export const TIME_CONTROL_SHORT_LABELS = {
  blitz_5: '5s',
  rapid_10: '10s',
  classical_30: '30s',
  live: 'Live',
  correspondence: 'Async',
};

export function isValidTimeControl(value) {
  return typeof value === 'string' && TIME_CONTROLS.includes(value);
}

export function getPerMoveLimitMs(timeControl) {
  return TIME_CONTROL_LIMITS_MS[timeControl] ?? null;
}
